import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createState",
    serviceName: "admin",
    query: gql`
      mutation createState($title: String!, $details: String) {
        createState(title: $title, details: $details) {
          messages
        }
      }
    `,
  },
};

export default schema;
